import { Element } from 'types';

const element: Element = {
  id: '',
  name: '',
  description: '',
  parents: [],
  children: [],
  tags: [],
  prime: false,
  base: false,
  final: false,
  exhausted: null,
  condition: null,
};

export default element;
